import { createChatBotMessage } from "react-chatbot-kit";
import BotAvatar from "./BotAvatar";

const botName = "Shelf21 AI Assistant";

const config = {
  botName: "Lulu (Shelf 21 AI Assistant)",
  customComponents: {
    botAvatar: (props) => <BotAvatar {...props} />,
    userAvatar: () => (
      <div
        style={{
          backgroundColor: "#eee",
          borderRadius: "50%",
          width: "30px",
          height: "30px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "20px"
        }}
      >
      🧑
      </div>
    ),
    header: () => null
  },
  initialMessages: [
    createChatBotMessage(`Hi! I'm ${botName}. Ask me anything about Shelf21. I will save you a ton of time.`)
  ],
  customStyles: {
    botMessageBox: {
      backgroundColor: "#0065FF"
    },
    chatButton: {
      backgroundColor: "#0065FF"
    }
  }
};

export default config;
